import React, { useState, useEffect } from 'react'
import { withRouter, useHistory, Redirect } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { routes } from '../../../../constantes/routes'
import UserModal from '../UserModal'
import { swalAlertError, swalSuccessGeneral } from '../../../../utils/swalAlert'
import { swalTitle } from '../../../../constantes/swalTitle'
import { onSubmitText } from '../../../../constantes/onSubmitText'
import Header from '../../../header/Header'
import validators from '../../../../utils/validationsRegEx'
import { usersActions } from '../../../../actions/usersActions'
import { businessunitsActions } from '../../../../actions/businessunitsActions'
import { userTypes } from '../../../../constantes/actionTypes'
import { swalMssgs } from '../../../../constantes/swalMssgs'

const NewUserContainer = () => {
  const history = useHistory()

  const userProfile = useSelector((state) => state.userProfile)
  const rolesList = useSelector((state) => state.rolesList)
  const zones = useSelector((state) => state.zones)
  const colors = useSelector((state) => state.colors)
  const businessunits = useSelector((state) => state.businessunits)

  const dispatch = useDispatch()
  const newUser = (user) => dispatch(usersActions.newUser(user))
  const getAllBusinessUnits = () =>
    dispatch(businessunitsActions.getAllBusinessUnits())

  const [inputs, setinputs] = useState({
    nombre: '',
    email: '',
    telefono: '',
    id_Rol: '',
    id_TipoZona: '',
    id_TipoColor: '2', /* Default Claro */
    businessUnits: [],
  })

  const [isDisable, setIsDisable] = useState(false)
  const [modalIsOpen, setModalIsOpen] = useState(true) // Modal abierto por defecto

  useEffect(() => {
    getAllBusinessUnits()
  }, [])

  const closeModal = () => {
    setModalIsOpen(false)
    history.push(routes.USERS)
  }

  const handleChange = (event) => {
    const value = event.target.value
    const name = event.target.name
    setinputs((inputs) => ({ ...inputs, [name]: value }))
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsDisable(true)
    try {
      // Transformar businessUnits a id_NegocioUnidades para el backend
      const { businessUnits, ...userData } = inputs
      const userDataWithBusinessUnits = {
        ...userData,
        id_NegocioUnidades: businessUnits.map((bu) => bu.id_NegocioUnidad),
      }

      const response = await newUser(userDataWithBusinessUnits)
      if (userTypes.NEW_USER_SUCCESS === response.type) {
        swalSuccessGeneral(swalTitle.CreadoCorrectamente, swalMssgs.NEW_SUCCES)
        closeModal()
      }
    } catch (error) {
      swalAlertError(error.payload)
      setIsDisable(false)
    }
  }

  const validateForm = () => {
    return (
      validators.emailFormat(inputs.email) &&
      (!validators.hasValue(inputs.telefono) ||
        validators.phoneNumberFormat(inputs.telefono)) &&
      validators.hasValue(inputs.id_Rol) &&
      validators.hasValue(inputs.nombre) &&
      inputs.businessUnits.length > 0
    )
  }

  return (
    <>
      {userProfile.roles.isBackofficeVer ? (
        <div className='products'>
          <Header
            text={'Alta nuevo usuario'}
            route={() => history.goBack()}
            backBtn={false}
          />
          <UserModal
            modalIsOpen={modalIsOpen}
            closeModal={closeModal}
            inputs={inputs}
            handleChange={handleChange}
            handleSubmit={handleSubmit}
            validateForm={validateForm}
            textBtn={onSubmitText.Crear}
            zones={zones}
            businessunits={businessunits}
            colors={colors}
            rolesList={rolesList}
            isEdit={false}
          />
        </div>
      ) : (
        <Redirect to={{ pathname: routes.MAIN }} />
      )}
    </>
  )
}

export default withRouter(NewUserContainer)
